import { toInitials } from '../utils/toInitials'
import { Contact } from './Contact'
import type { ISupplier } from '~/types/supplier/models'

export function Supplier(o: ISupplier): ISupplier {
  const fn = '[cynqueModules/dataObjects/Supplier.ts] Supplier |'
  if (!o) {
    throw new Error(`${fn} Supplier called with falsey supplier`)
  }

  const obj = { ...o }

  if (o.primaryContact) {
    o.primaryContact.descr = Contact(o.primaryContact).descr
  }
  if (o.secondaryContact) {
    o.secondaryContact.descr = Contact(o.secondaryContact).descr
  }
  obj.avatar = getSupplierAvatar(o.descr)

  return obj
}

//
// helper functions
//

export function getSupplierAvatar(fullName: string) {
  return {
    descr: toInitials(fullName),
    type: 'supplierName',
  }
}
